module.exports = __webpack_public_path__ + "img/logo-dark-small.17409782.png";